import { render, staticRenderFns } from "./Dealer_list.vue?vue&type=template&id=130281cc&scoped=true"
import script from "./Dealer_list.vue?vue&type=script&lang=js"
export * from "./Dealer_list.vue?vue&type=script&lang=js"
import style0 from "./Dealer_list.vue?vue&type=style&index=0&id=130281cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130281cc",
  null
  
)

export default component.exports